import { Button, Text, Box, Input } from "@chakra-ui/react";
import WithAuth from "../components/hoc/with-auth";
import { AuthLayout } from "../components/layouts/index";
import { LayoutWithSidebar } from "../components/layouts/layout-with-sidebar.tsx/index";
import DealsHistoryPage from "../components/pages/deals-history-page";

const DealsHistory = () => {
  return (
    <>
      <WithAuth>
        <LayoutWithSidebar
          pageTitle="Deals History"
          pageDesc="List of all the deals"
        >
          <DealsHistoryPage />
        </LayoutWithSidebar>
      </WithAuth>
    </>
  );
};

export default DealsHistory;
